import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  fetchVisitorTypes,
  fetchIdProofTypes,
  fetchMeetingVenues,
  insertAppointment,
  fetchNationality,
  fetchGateDetails,
  fetchBuildingsByGate,
} from "../../services/Api";
import Webcam from "react-webcam"; // Import react-webcam
import { User } from "react-feather"; // Import the User icon
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import * as mp from "@mediapipe/selfie_segmentation";
import { createWorker } from "tesseract.js";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import { axiosInstance } from "../../services/Api";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 18px 7px 33px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Heading = styled.h1`
  font-size: 25px;
  font-family: "Segoe UI", Semibold;
  color: #2b3497;
  margin: 0;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  width: 81px;
  height: 32px;
  border-radius: 7px;
  box-shadow: 0px 5px 10px #2b349754;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  font-family: "Segoe UI", Semibold;
`;

const ResetButton = styled(Button)`
  background-color: red;
`;

const SubmitButton = styled(Button)`
  background-color: #2b3497;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 9px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  flex: 1;
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 27px;
  opacity: 1;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-family: "Segoe UI", Semibold;
  color: #000000;
  margin-bottom: 5px;
  font-weight: 600;
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 415px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: "Segoe UI", Regular;
    background: transparent;
    border-bottom: 1px solid #2b3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2b3497;
    }
  }
  @media (max-width: 1920px) {
    width: 745px;
  }
  @media (max-width: 1820px) {
    width: 689px;
  }
  @media (max-width: 1720px) {
    width: 644px;
  }
  @media (max-width: 1620px) {
    width: 587px;
  }
  @media (max-width: 1520px) {
    width: 587px;
  }
  @media (max-width: 1420px) {
    width: 487px;
  }
`;
const ProfileCard = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Circle = styled.div`
  width: 131px;
  height: 131px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;

const ProfileIcon = styled.div`
  width: 134px;
  height: 131px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const PlusIcon = styled.div`
  width: 47px;
  height: 23px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bfbfbf;
  font-size: 44px;
  font-weight: 700;
`;

const ProfileText = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 18px;
  color: #ff3030;
  margin-bottom: 20px;
`;
const VisitorPhotoHeading = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 25px;
  font-weight: 700;
  color: #000000;
  text-align: center;
  margin-bottom: 10px;
`;

const PhotoButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: #343d9b;
  box-shadow: 0px 10px 10px #2b349733;
  border: 2px solid #343d9b;
  border-radius: 8px;
  opacity: 1;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 20px;
`;

const ActionButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: transparent;
  border: 2px solid #343d9b;
  border-radius: 8px;
  box-shadow: 0px 10px 10px #2b349733;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 20px;
  @media (max-width: 1420px) and (min-width: 1220px) {
    width: 125px;
  }
  @media (max-width: 1220px) and (min-width: 1020px) {
    width: 100px;
  }
`;
const CheckboxRowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  flex-direction: column;
`;
const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-family: "Segoe UI", Semibold;
  font-size: 14px;
`;
const CheckboxContainernew = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(100px, 1fr)
  ); /* Creates responsive grid */
  gap: 10px; /* Adds space between checkboxes */
  max-width: 500px; /* Adjust the width as needed */
`;

const PrivacyLink = styled.a`
  color: #2b3497;
  margin-left: 5px;
  text-decoration: none;
  cursor: pointer;
`;
const WebcamContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
`;
const ButtonRow = styled.div`
  display: flex;
  gap: 10px; /* Adjust gap between buttons */
  margin-bottom: 20px; /* Optional: Adjust margin bottom */
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  font-family: "Segoe UI", Semibold;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #000;
  &:hover {
    color: #2b3497;
  }
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #2B3497;
    color: #2B3497;
  `}
`;
const Checkbox = styled.input`
  width: 18px; /* Increases the size of the checkbox */
  height: 20px;
  margin-right: 8px;
`;
const CheckboxLabel = styled.span`
  font-weight: 400;
  color: #000;
  font-size: 16px;
  margin-right: 8px; /* Adds space between the label and checkbox */
`;
const CheckboxLabelnew = styled.span`
  display: inline-flex;
  align-items: center; /* Ensures vertical alignment of the checkbox and text */
  gap: 8px; /* Adds space between the checkbox and text */
  font-size: 14px; /* Adjust based on your preferred font size */
  margin: 5px 0;
  font-weight: 400;
  color: #000;
`;

const TabContent = styled.div`
  display: ${({ active }) => (active ? "block" : "none")};
`;
const HeaderN = styled.h3`
  margin-top: 16px;
  color: ${(props) =>
    props.disabled ? "#a9a9a9" : "#2B3497"}; /* Change color if disabled */
`;

const DropdownContainer = styled.div`
  margin-top: 16px;
`;

const DropdownLabel = styled.label`
  font-weight: 600;
  margin-right: 8px;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;

const InputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? "flex" : "none")};
  gap: 14px;
`;

const SpinnerInput = styled.input`
  padding: 10px;
  width: 60px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const SpinnerInputLabel = styled.label`
  font-weight: 600;
`;

const RecurrenceInput = styled.input`
  padding: 10px;
  width: 80px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  margin-left: 8px;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const AdditionalInputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? "flex" : "none")};
  flex-direction: column;
  align-items: flex-start;
`;
const AdditionalInputContainerN = styled.div`
  margin-top: 16px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const SelectedValuesContainer = styled.div`
  margin-top: 10px;
  padding: 12px;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
`;

const SelectedHeader = styled.h4`
  margin-bottom: 11px;
  font-weight: bold;
  color: #293495;
`;

const ValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const SelectedValue = styled.div`
  font-weight: bold;
  color: #000;
`;

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SwitchLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
`;

const Switch = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const SwitchText = styled.span`
  font-weight: bold;
  margin-left: 10px;
  color: ${({ isOn }) =>
    isOn ? "#28a745" : "#6c757d"}; // Green for Yes, Gray for No
`;

const SwitchSlider = styled.div`
  width: 50px;
  height: 24px;
  background-color: ${({ isOn }) =>
    isOn ? "#28a745" : "#ccc"}; // Green for Yes, Gray for No
  border-radius: 34px;
  position: relative;
  transition: 0.4s;

  &:before {
    content: "";
    position: absolute;
    height: 20px;
    width: 20px;
    left: ${({ isOn }) =>
      isOn ? "26px" : "4px"}; // Moves the slider based on the toggle state
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const InputFieldContainer = styled.div`
  margin-top: 20px;
`;

const InputLabel = styled.label`
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
`;
const InputLabelN = styled.label`
  margin-bottom: 5px;
  display: block;
  font-weight: 600;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: "Arial", sans-serif;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  box-sizing: border-box;
  resize: vertical;

  &:focus {
    border-color: #28a745;
  }
`;
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  background: white;
  width: 500px;
  max-height: 80%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  text-align: left;
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #293495; /* Custom scrollbar thumb color */
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ff3030; /* Hover color */
  }

  /* Firefox scrollbar */
  scrollbar-color: #293495 #f1f1f1;
  scrollbar-width: thin;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the button horizontally */
  margin-top: 20px;
`;

const CloseButton = styled.button`
  background-color: #293495;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #ff3030;
  }
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#ffffff, #f5f5f5, #ffffff);
  box-shadow: 0px 0px 1px #0000004a;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  z-index: 1000;
  width: 500px;
`;

const PopupButton = styled.button`
  background-color: #2b3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2b349754;
  cursor: pointer;
  margin-left: 10px;
  &.no-button {
    background-color: red; /* Change color to red for No button */
  }
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2b3497;
  margin-bottom: 20px;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
`;

const Chip = styled.div`
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 5px 10px;
  margin: 2px;
  display: flex;
  align-items: center;
  font-size: 14px;
`;
const FormRow = styled.div`
  display: flex;
  gap: 20px; /* Adjust spacing between inputs */
  justify-content: space-between;
  width: 100%;
`;
const RemoveChipButton = styled.span`
  color: #ff0000;
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
`;

const InputField = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  margin-left: 5px;
  padding: 5px;
`;

const SuggestionBox = styled.ul`
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 5px 0 0;
  padding: 0;
  list-style: none;
  background: white;
  max-height: 150px;
  overflow-y: auto;
`;

const SuggestionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const AppoinmentFormPage = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [selectedGate, setSelectedGate] = useState("");
  const [activeTab, setActiveTab] = useState("details"); // State for tab management
  const [selectedVisitorType, setSelectedVisitorType] = useState("");
  const [selectedIdProofType, setSelectedIdProofType] = useState("");

  const [visitorTypes, setVisitorTypes] = useState([]);
  const [idProofTypes, setIdProofTypes] = useState([]);

  const [meetingvenues, setMeetingvenues] = useState([]);
  const [gates, setGates] = useState([]);
  const [buildings, setBuildings] = useState([]);

  const [isChecked, setIsChecked] = useState(false);
  const [recurrencePattern, setRecurrencePattern] = useState("");
  const [selectedrecurrencePattern, setSelectedrecurrencePattern] =
    useState("");
  const [recurrencePatternAPI, setRecurrencePatternAPI] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedWeekday, setSelectedWeekday] = useState("");
  const [selectedWeekdayAPI, setSelectedWeekdayAPI] = useState("");

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthAPI, setSelectedMonthAPI] = useState("");

  const [isAllDayChecked, setIsAllDayChecked] = useState(false);
  const [isBlockCalenderChecked, setIsBlockCalenderChecked] = useState(false);

  const [recurEvery, setRecurEvery] = useState(0);

  const [isAssistanceRequired, setIsAssistanceRequired] = useState(false);
  const [isServiceProviderAccess, setIsServiceProviderAccess] = useState(false);
  const [isWiFiRequired, setIsWiFiRequired] = useState(false);
  const [isEscortRequired, setIsEscortRequired] = useState(false);
  const [isadditionalNotify, setIsAdditionalNotify] = useState(false);
  const [isbehalfNotify, setIsBehalfNotify] = useState(false);

  const [additionalMessage, setAdditionalMessage] = useState("");
  const [checkInInstructions, setCheckInInstructions] = useState("");

  const toggleAssistanceRequired = () =>
    setIsAssistanceRequired(!isAssistanceRequired);
  const toggleServiceProviderAccess = () =>
    setIsServiceProviderAccess(!isServiceProviderAccess);
  const toggleWiFiRequired = () => setIsWiFiRequired(!isWiFiRequired);
  const toggleEscortRequired = () => setIsEscortRequired(!isEscortRequired);
  const toggleadditionalNotifyRequired = () =>
    setIsAdditionalNotify(!isadditionalNotify);
  const togglebehalfNotifyRequired = () => setIsBehalfNotify(!isbehalfNotify);

  const handleAdditionalMessageChange = (e) =>
    setAdditionalMessage(e.target.value);
  const handleCheckInInstructionsChange = (e) =>
    setCheckInInstructions(e.target.value);
  const [nationalityList, setNationalityList] = useState([]);
  const [fieldData, setFieldData] = useState("");

  const location = useLocation();
  const { visitorTypeDetails } = location.state || {};
  console.log("visitorTypeDetails", visitorTypeDetails);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };
  const handleDropdownChange = (event) => {
    console.log("event.target", event.target);
    const selectedText = event.target.options[event.target.selectedIndex].text;
    console.log("selectedText", selectedText);
    // This gets the text of the selected option

    setRecurrencePattern(event.target.value);
    if (event.target.value == "1") {
      setRecurrencePatternAPI(1);
    }
    if (event.target.value == "2") {
      setRecurrencePatternAPI(2);
    }
    if (event.target.value == "3") {
      setRecurrencePatternAPI(3);
    }
  };
  const handleDayChange = (event) => {
    setSelectedDay(event.target.value);
  };
  const handleWeekdayCheckboxChange = (weekday) => {
    setSelectedWeekday(
      (prev) =>
        prev.includes(weekday)
          ? prev.filter((day) => day !== weekday) // Remove if already selected
          : [...prev, weekday], // Add if not selected
    );
  };
  const handleMonthCheckboxChange = (month) => {
    setSelectedMonth(
      (prev) =>
        prev.includes(month)
          ? prev.filter((m) => m !== month) // Remove if already selected
          : [...prev, month], // Add if not selected
    );
  };
  const handleAllDayCheckboxChange = () => {
    setIsAllDayChecked((prev) => !prev);
  };
  const handleBlockCalenderCheckboxChange = () => {
    setIsBlockCalenderChecked((prev) => !prev);
  };

  const handleRecurEveryChange = (event) => {
    const value = event.target.value;
    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
      setRecurEvery(value === "" ? 0 : Number(value));
    }
  };

  const handleRecurEveryKeyDown = (event) => {
    // Reverse the arrow key behavior
    if (event.key === "ArrowUp") {
      event.preventDefault();
      setRecurEvery((prev) => Math.max(0, Number(prev || 0) - 1)); // Decrease on up arrow
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      setRecurEvery((prev) => Number(prev || 0) + 1); // Increase on down arrow
    }
  };

  const getRecurrencePatternAPIValue = () => {
    switch (recurrencePattern) {
      case "1":
        return 1;
      case "2":
        return 2;
      case "3":
        return 3;
      default:
        return null; // Handle default case as needed
    }
  };

  // Generate an array for days 1 to 31
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const [employeeData, setEmployeeData] = useState([]); // To store the employee data
  const [employeeId, setEmployeeId] = useState("");
  const [defaultDatetime, setDefaultDatetime] = useState([]); // To store the employee data
  const [timeLimits, setTimeLimits] = useState({
    startHour: 9,
    startMinute: 0,
    endHour: 18,
    endMinute: 0,
  });

  useEffect(() => {
    if (visitorTypeDetails) {
      setFormData((prevData) => ({
        ...prevData,
        selectedVisitorTypeId: visitorTypeDetails.id,
      }));
    }
    setFieldData(visitorTypeDetails.groupAppointmentInputField[0]);
    setCheckInInstructions(visitorTypeDetails?.checkinInstruction || "");
    console.log("groupAppointmentInputField", fieldData);
    const getVisitorTypes = async () => {
      const storedEmpId = localStorage.getItem("employeeId");

      try {
        const types = await axios.get(
          `/VisitorType/GetVisitorTypeDetailsByEmpId/${storedEmpId}`,
        );
        setVisitorTypes(types.data);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };
    const getEmpname = localStorage.getItem("username");

    const fetchEmployeeMail = async () => {
      try {
        const response = await axios.get(`/User/UserDets/${getEmpname}`);
        console.log("response", response.data);
        if (response.data.length > 0) {
          localStorage.setItem("USERID", response.data[0].id);
          setEmployeeId(response.data[0].empId);
        } else {
          console.error("No user data found for username:", getEmpname);
          // Optionally handle case where no data is found
        }
      } catch (error) {
        console.error("Error fetching employee email:", error);
      }
    };
    const getIdProofTypes = async () => {
      try {
        const types = await fetchIdProofTypes();
        setIdProofTypes(types);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };
    const getMeetiingOn = async () => {
      try {
        const response = await axios.get(
          "/Appointment/GetMeetingFromAndMeetingTo",
        );
        const { meetingFrom, meetingTo } = response.data;

        const [startHour, startMinute] = meetingFrom.split(":").map(Number);
        const [endHour, endMinute] = meetingTo.split(":").map(Number);

        setTimeLimits({ startHour, startMinute, endHour, endMinute });
      } catch (error) {
        console.error("Error fetching meeting time limits:", error);
      }
    };

    const getMeetingvenues = async () => {
      try {
        const venues = await fetchMeetingVenues();
        setMeetingvenues(venues);
        const defaultVenue = venues.find((venue) => venue.defaultLocation);

        if (defaultVenue) {
          setFormData((prev) => ({
            ...prev,
            meetingVenue: defaultVenue.locationName,
          }));

          // Fetch gates (independent try/catch so it can't block anything else)
          try {
            const menuNameResponse = await axiosInstance.get(
              `/Location/GetGatesByLocationID?locationID=${defaultVenue.id}`,
            );
            const gatesData = Array.isArray(menuNameResponse.data)
              ? menuNameResponse.data
              : menuNameResponse.data?.data || [];
            setGates(gatesData);

            const defaultVenueGate = gatesData.find((venue) => venue.defaultGate);
            if (defaultVenueGate) {
              const gateID = parseInt(defaultVenueGate.id, 10);
              const selectedGateObject = gatesData.find((gate) => gate.id === gateID);
              setSelectedGate(selectedGateObject);
            }
          } catch (gateError) {
            console.error("Error fetching gates:", gateError);
          }

          // Buildings are now fetched via their own dedicated call
          getBuildingsForVenue(defaultVenue.id);
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };

    const getBuildingsForVenue = async (venueId) => {
      try {
        const buildingsResponse = await axiosInstance.get(
          `/Location/GetBuildingAndGateByLocationId/${venueId}`,
        );
        const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
        setBuildings(fetchedBuildings);
      } catch (error) {
        console.error("Error fetching buildings for venue:", error);
        setBuildings([]);
      }
    };
    // const getGateDetails = async () => {
    //   try {
    //     const venues = await fetchGateDetails();
    //     setGates(venues);
    //   } catch (error) {
    //     console.error('Error fetching Gate venues:', error);
    //   }
    // };
    const fetchAppointmentDataeemp = async () => {
      try {
        const responseeEMP = await axios.get("/Employee/");
        console.log("response", responseeEMP);
        console.log("Employee Data:", responseeEMP.data);
        setEmployeeData(responseeEMP.data);
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    };
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find((n) => n.isDefault === true);
        if (defaultNation) {
          setFormData((prevData) => ({
            ...prevData,
            nationality: defaultNation.name,
          }));
          setDefaultCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getMeetiingOn();
    getMeetingvenues();
    getNationality();
    fetchAppointmentDataeemp();
    fetchEmployeeMail();
    getVisitorTypes();
    getIdProofTypes();
    // getGateDetails();
  }, []);

  const [inputValueBehalf, setInputValueBehalf] = useState("");

  const [inputValue, setInputValue] = useState("");
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [onBehalfEmail, setOnBehalfEmail] = useState("");
  const [filteredBehalfSuggestions, setFilteredBehalfSuggestions] = useState(
    [],
  );
  const handleInputChangeN = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Filter suggestions only if input is not empty
    if (value) {
      setFilteredSuggestions(
        employeeData.filter(
          (emp) =>
            emp.employeeMailId &&
            emp.employeeMailId.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleSuggestionClick = (email) => {
    if (!selectedEmails.includes(email)) {
      setSelectedEmails((prev) => [...prev, email]);
    }
    setInputValue("");
    setFilteredSuggestions([]);
  };
  const handleBehalfInputChange = (e) => {
    const value = e.target.value;
    setInputValueBehalf(value);

    if (value) {
      setFilteredBehalfSuggestions(
        employeeData.filter(
          (emp) =>
            emp.employeeMailId &&
            emp.employeeMailId.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    } else {
      setFilteredBehalfSuggestions([]);
    }
    // const suggestions = employeeData.filter((emp) =>
    //   emp.employeeMailId.toLowerCase().includes(value.toLowerCase())
    // );
    // setFilteredBehalfSuggestions(suggestions);
  };
  const [onBehalfEmployeeId, setOnBehalfEmployeeId] = useState(null); // NEW

  const handleBehalfSuggestionClick = (email) => {
    const selectedEmp = employeeData.find(
      (emp) => emp.employeeMailId === email,
    );

    console.log("selectedEmp", selectedEmp);

    if (selectedEmp) {
      setOnBehalfEmail(selectedEmp.employeeMailId);
      setOnBehalfEmployeeId(selectedEmp.id); // Set the ID
    }
    setInputValueBehalf("");
    setFilteredBehalfSuggestions([]);
  };

  const handleChipRemove = (email) => {
    setSelectedEmails((prev) => prev.filter((e) => e !== email));
  };
  useEffect(() => {
    // Log the selected emails to the console whenever they update
    console.log("Selected Emails:", selectedEmails);
  }, [selectedEmails]);

  const handleKeyDown = (e) => {
    if (
      e.key === "Enter" &&
      inputValue &&
      !selectedEmails.includes(inputValue)
    ) {
      setSelectedEmails((prev) => [...prev, inputValue]);
      setInputValue("");
      setFilteredSuggestions([]);
    }
  };
  useEffect(() => {
    if (selectedGate) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        gate: selectedGate.name, // Use the gate name in the form data
      }));
    }
  }, [selectedGate]);
  const [defaultCode, setDefaultCode] = useState({});
  
  const handleDateChange = (date, field) => {
  console.log("Selected date:", date, "Field:", field);

  if (
    date &&
    Object.prototype.toString.call(date) === "[object Date]" &&
    !isNaN(date)
  ) {
    const now = new Date();
    const isTimeUnchanged =
      date.getHours() === 0 &&
      date.getMinutes() === 0 &&
      date.getSeconds() === 0;

    let finalDate = date;

    if (isTimeUnchanged) {
      finalDate = new Date(date);

      if (field === "meetingTo" && formData.meetingFrom) {
        // Set Meeting To = Meeting On time + 30 mins
        const meetingOnDate = new Date(formData.meetingFrom);
        finalDate.setHours(meetingOnDate.getHours(), meetingOnDate.getMinutes() + 30, 0, 0);
      } else {
        // Set to current time for Meeting On
        finalDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: finalDate,
    }));

    if (formErrors[field]) {
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        [field]: false,
      }));
    }
  } else {
    console.error("Invalid date value:", date);
  }
};

  const currentDateTime = new Date(); // Current date and time

  // Function to filter out times earlier than the current time
  const filterPassedTime = (time) => {
    if (!(time instanceof Date)) return false;

    const selectedDate = new Date(time);
    const now = new Date();

    const { startHour, startMinute, endHour, endMinute } = timeLimits;

    const selectedMinutes =
      selectedDate.getHours() * 60 + selectedDate.getMinutes();
    const startMinutes = startHour * 60 + startMinute;
    const endMinutes = endHour * 60 + endMinute;

    const isWithinWorkingHours =
      selectedMinutes >= startMinutes && selectedMinutes <= endMinutes;

    const isSameDay = now.toDateString() === selectedDate.toDateString();
    const isFutureTime = selectedDate.getTime() > now.getTime();

    return isWithinWorkingHours && (!isSameDay || isFutureTime);
  };

  // Function to highlight the current time
  const highlightTime = (time) => {
    const now = new Date();
    const timeToHighlight = now.getHours() * 60 + now.getMinutes();
    const selectedTime = time.getHours() * 60 + time.getMinutes();

    // Highlight the time close to the current system time
    return selectedTime === timeToHighlight ? "highlight-time" : "";
  };

  const validateMeetingTimes = () => {
  if (formData.meetingFrom && formData.meetingTo) {
    const meetingFromDate = moment(formData.meetingFrom);
    const meetingToDate = moment(formData.meetingTo);
    const now = moment();

    const minMeetingFrom = now.clone().subtract(5, 'minutes');
    if (meetingFromDate.isBefore(minMeetingFrom)) {
      toast.error("Meeting On Time is not Valid");
      setFormErrors((prev) => ({ ...prev, meetingFrom: true }));
      return false;
    }

    if (meetingFromDate.isSameOrAfter(meetingToDate)) {
      toast.error("Meeting end time must be greater than the start time");
      setFormErrors((prev) => ({ ...prev, meetingTo: true }));
      return false;
    }

    const minMeetingTo = meetingFromDate.clone().add(15, 'minutes');
    if (meetingToDate.isBefore(minMeetingTo)) {
      toast.warning("Meeting To Time is less than 15 mins");
      setFormErrors((prev) => ({ ...prev, meetingTo: true }));
      return false;
    }

    if (meetingFromDate.isSame(meetingToDate, "day") && isChecked) {
      toast.error("Select more than one day for Repeat Visit.");
      setFormErrors((prev) => ({ ...prev, meetingTo: true }));
      return false;
    }

    // Multi-day range selected but Repeat Visit not checked
    if (
      meetingToDate.isAfter(meetingFromDate, "day") &&
      !isChecked
    ) {
      return "needs_repeat_visit"; // special signal — no toast here
    }
  }
  return true;
};

  const adjustForTimezoneOffset = (date) => {
    if (!date) return null;
    const timezoneOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(date.getTime() - timezoneOffset)
      .toISOString()
      .slice(0, -1);
    return localISOTime;
  };

  // const handleGateChange = async (event) => {
  //   const gateID = event.target.value;

  //   // If no gate is selected, clear selectedGate and formData.gate
  //   if (!gateID) {
  //     setSelectedGate(null);
  //     setFormData({ ...formData, gate: '' });
  //     setBuildings([]);
  //     return;
  //   }

  //   const selectedGateObject = gates.find(gate => gate.id === parseInt(gateID, 10));
  //   setSelectedGate(selectedGateObject);
  //   setFormData({ ...formData, gate: gateID });

  //   try {
  //     const buildings = await fetchBuildingsByGate(gateID);
  //     setBuildings(buildings);
  //   } catch (error) {
  //     console.error('Error fetching buildings:', error);
  //   }
  // };

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    // groupLeaderName: '',
    visitorEmail: "",
    gender: "",
    nationality: "",
    visitorMobile: "",
    // company: '',
    meetingFrom: null,
    meetingTo: null,
    selectedVisitorTypeId: selectedVisitorType,
    selectedIdProofTypeId: selectedIdProofType,
    idProofNo: "",
    gate: "",
    building: "",
    // visitorPhoto: '',
    purpose: "",
  });

  const [formErrors, setFormErrors] = useState({
    firstName: fieldData.visitorNameField,
    lastName: fieldData.visitorNameField,
    gender: fieldData.genderField,
    nationality: fieldData.nationalityField,

    // groupLeaderName: false,
    visitorEmail: fieldData.visitorEmailField,
    visitorMobile: fieldData.visitorMobileField,
    meetingVenue: fieldData.locationField,
    // company: fieldData.visitorCompanyField,
    meetingFrom: fieldData.meetingOnField,
    meetingTo: fieldData.meetingToField,
    selectedVisitorTypeId: false,
    selectedIdProofTypeId: fieldData.idProofTypeField,
    gate: fieldData.gateField,
    building: fieldData.areaField,
    purpose: fieldData.purpose,
  });

  const handleReset = () => {
    setIsCheckedP(false);
    setIsCheckedC(false);
    setSelectedGate();
    setFormData((prev) => ({
      ...prev,
      firstName: "",
      middleName: "",
      lastName: "",
      gender: "",
      nationality: "",
      // groupLeaderName: '',
      visitorEmail: "",
      visitorMobile: "",
      // visitorPhoto: '',
      // company: '',
      meetingFrom: null,
      meetingTo: null,
      // selectedVisitorTypeId: '',
      selectedIdProofTypeId: "",
      idProofNo: "",
      gate: "",
      building: "",
      // visitorPhoto: '',
      purpose: "",
      selectedVisitorTypeId: prev.selectedVisitorTypeId,
    }));
    setProfileImage("");
    // setFormErrors({
    //   firstName: fieldData.visitorNameField,
    //   lastName: fieldData.visitorNameField,
    //   gender: fieldData.genderField,
    //   nationality: fieldData.nationalityField,

    //   // groupLeaderName: false,
    //   visitorEmail: fieldData.visitorEmailField,
    //   visitorMobile: fieldData.visitorMobileField,
    //   meetingVenue: fieldData.locationField,
    //   // company: fieldData.visitorCompanyField,
    //   meetingFrom: fieldData.meetingOnField,
    //   meetingTo: fieldData.meetingToField,
    //   selectedVisitorTypeId: false,
    //   selectedIdProofTypeId: fieldData.idProofTypeField,
    //   gate: fieldData.gateField,
    //   building: fieldData.areaField,
    //   purpose: fieldData.purpose,

    // });
    setMeetingvenues([]);

    const getMeetingvenues = async () => {
      try {
        const venues = await fetchMeetingVenues();
        setMeetingvenues(venues);
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getMeetingvenues();

    setIsChecked(false);
    setRecurrencePattern(""); // Set to default value (1 for Daily)
    setSelectedDay("");
    setSelectedWeekday("");
    setSelectedMonth("");
    setRecurEvery("");
    setIsAllDayChecked(false);
    setIsBlockCalenderChecked(false);
    setIsAssistanceRequired(false);
    setIsServiceProviderAccess(false);
    setIsWiFiRequired(false);
    setIsEscortRequired(false);
    setAdditionalMessage("");
    setCheckInInstructions("");
    setIsAdditionalNotify("");
    setIsBehalfNotify("");

    console.log("Form reset");
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };

  const handleChangeLo = async (e) => {
    const { name, value } = e.target;

    // Update location + clear gate/building
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "meetingVenue" ? { gate: "", building: "" } : {}),
    }));

    if (formErrors[name]) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: false,
      }));
    }

    if (name === "meetingVenue") {
      // Clear UI states for gates & buildings
      setGates([]);
      setBuildings([]);
      setSelectedGate(null); // reset selectedGate
    }

    const selectedLocation = meetingvenues.find(
      (item) => item.locationName === value,
    );
    if (selectedLocation) {
      try {
        const menuNameResponse = await axiosInstance.get(
          `/Location/GetGatesByLocationID?locationID=${selectedLocation.id}`,
        );
        const buildingsResponse = await axiosInstance.get(
          `/Location/GetBuildingAndGateByLocationId/${selectedLocation.id}`,
        );
        const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
        setGates(menuNameResponse.data);
        setBuildings(fetchedBuildings);
      } catch {
        toast.error("Error fetching gates");
      }
    }
  };

  const handleGateChange = async (event) => {
    const gateID = event.target.value;

    if (!gateID) {
      // User selected "Select Gate"
      setSelectedGate(null);
      setFormData((prev) => ({ ...prev, gate: "", building: "" }));
      // setBuildings([]);
      return;
    }

    const selectedGateObject = gates.find(
      (gate) => gate.id === parseInt(gateID, 10),
    );
    setSelectedGate(selectedGateObject);

    // Keep formData in sync
    setFormData((prev) => ({
      ...prev,
      gate: gateID,
      building: "", // reset building when gate changes
    }));

    // try {
    //   const buildings = await fetchBuildingsByGate(gateID);
    //   setBuildings(buildings);
    // } catch (error) {
    //   console.error("Error fetching buildings:", error);
    // }
  };

  const handleChangeNew = (e) => {
    const { name, value } = e.target;
    console.log("visitor type", e.target.value);
    const selectedText = e.target.options[e.target.selectedIndex].text; // Get the selected text
    console.log("Selected text:", selectedText);
    const selectedType = visitorTypes.find(
      (type) => type.id === parseInt(value),
    );
    console.log("Selected Visitor Type Object:", selectedType);

    if (selectedText == "Service Engineer") {
      console.log("show instruction");
      setCheckInInstructions(`Use Hard Hat and Eye Protection in the Working Zone.Use Hand protection Gloves, Safety Shoe and Belts while working in the site.Use well Insulated wiring, proper plugs while using any electrical Machine.Use proper Scaffolding while working at Heights.

      `);
    } else if (selectedType) {
      setCheckInInstructions(selectedType.checkinInstruction || "");
    }

    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };
  const [existingData, setExistingData] = useState("");
  function getCurrentDateTime() {
    const date = new Date();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  const [appId, setAppId] = useState("");
  const [blackData, setBlackData] = useState("");

  const handleSubmit = async (event) => {
    const formattedMobileNumber = `${defaultCode}-${formData.visitorMobile}`;
    if (formData.visitorMobile) {
      const blackListCheck = await axios.get(
        `/BlackList/${formattedMobileNumber}`,
      );
      const isBlacklisted = blackListCheck.data;
      setBlackData(isBlacklisted); // Optional
      if (isBlacklisted) {
        toast.error("Person with this mobile number is blacklisted");
        return;
      }
    }

    event.preventDefault();
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }
    if (isChecked == 1) {
      if (recurrencePatternAPI) {
        // if (recurrencePatternAPI == 1 && !recurEvery) {
        //   toast.error("Please fill the recur every field");
        //   return;
        // }
        if (recurrencePatternAPI == 2 && !newSelectedRecurrencePattern) {
          toast.error("Please  Select the Weekdays");
          return;
        }
        if (recurrencePatternAPI == 3 && !newSelectedRecurrencePattern) {
          toast.error("Please  Select the Months");
          return;
        }
      } else {
        toast.error("Please select the recurrence pattern");
        return;
      }
    }

    // Log the new selected recurrence pattern before setting the state
    console.log(
      "Selected Recurrence Pattern before update:",
      newSelectedRecurrencePattern,
    );

    let valid = true;
    const errors = {};

    // if (formData.groupLeaderName === '') {
    //   errors.groupLeaderName = true;
    //   valid = false;
    // }
    if (fieldData.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    // if (fieldData.visitorCompanyField && formData.company === '') {
    //   errors.company = true;
    //   valid = false;
    // }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (fieldData.meetingOnField && formData.meetingFrom === null) {
      errors.meetingFrom = true;
      valid = false;
    }
    if (fieldData.meetingToField && formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (fieldData.locationField && formData.meetingVenue === "") {
      errors.meetingVenue = true;
      valid = false;
    }
    if (fieldData.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData.idProofTypeField && formData.selectedIdProofTypeId === "") {
      errors.selectedIdProofTypeId = true;
      valid = false;
    }
    if (fieldData.idProofNumberField && formData.idProofNo === "") {
      errors.idProofNo = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    if (fieldData.visitorMobileField && formData.visitorMobile === null) {
      errors.visitorMobile = true;
      valid = false;
    }
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
        return;
      }
    }
    if (isbehalfNotify) {
      if (onBehalfEmail == "") {
        toast.error("please fill the message to on behalf field");
        return;
      }
    }

    // if (!validateMeetingTimes()) {
    //   valid = false;
    // }
    const timeValidation = validateMeetingTimes();
    if (timeValidation === "needs_repeat_visit") {
      if (!valid) {
        // Mandatory fields are missing — stay on details tab, show field errors + toast
        setFormErrors(errors);
        toast.error("please fill all fields");
        return;
      }
      // All fields valid — switch to additional tab and prompt repeat visit
      setActiveTab("additional");
      toast.error("Please select the Repeat Visit");
      return;
    }
    if (timeValidation === false) {
      valid = false;
    }

    console.log("Validation result:", valid);

    if (!valid) {
        setFormErrors(errors);
        toast.error("please fill all fields");
        return;
      }

    if(activeTab == "details"){
      setActiveTab("additional");
      return;
      }

    setFormErrors(errors);
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localDate = new Date(date - tzOffset); // Apply the offset to get local time
      return localDate.toISOString().slice(0, -1); // Remove the 'Z' from the ISO string
    };

    // if (formData.visitorPhoto == '') {
    //   toast.error(
    //     "photo is not captured, Please upload the photo "
    //   )
    //   return
    // }

    const responseGroup = await axios.get(
      `/GroupAppointment/GroupAppointment/${formattedMobileNumber}`,
    );
    console.log("responseGroup", responseGroup.data);
    setExistingData(responseGroup.data);
    const currentDateTime = getCurrentDateTime();
    console.log("currentDate", currentDateTime);
    console.log("responseGroup.data.validTill", responseGroup.data.validTill);
    try {
      function formatDateTime(date) {
        const pad = (num) => String(num).padStart(2, "0");

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Months are zero-indexed
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }

      // Example usage
      const meetingFrom = new Date(formData.meetingFrom); // Assuming formData.meetingFrom is a valid date
      const formattedDateTime = formatDateTime(meetingFrom);

      const empId = localStorage.getItem("employeeId");
      const response = await axios.get(
        `/GroupAppointment/GetGroupAppointmentbyHost/${empId},${formattedDateTime}`,
      );

      if (
        response.data &&
        response.data.some((appointment) => {
          const formattedExistingMeetingOn = new Date(appointment.meetingOn)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const formattedExistingValidTill = new Date(appointment.validTill)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const formattedFormMeetingOn = new Date(formData.meetingFrom)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");

          // Check if the selected meetingOn time matches an existing appointment's meetingOn or validTill
          return (
            formattedExistingMeetingOn === formattedFormMeetingOn ||
            formattedExistingValidTill === formattedFormMeetingOn
          );
        })
      ) {
        toast.error(
          "An appointment already exists for the selected time. Please choose another time slot.",
        );

        return; // Exit function if the appointment cannot be booked
      }
    } catch (error) {
      console.error("Error checking appointment availability:", error);
      toast.error(
        "Failed to check appointment availability. Please try again.",
      );
      return; // Exit function if there's an error in checking availability
    }

    if (responseGroup.data.validTill > currentDateTime) {
      toast.error("Appointment is already exists");
      return;
    }
    if (responseGroup.data?.RepeatVisit) {
      toast.error("Appointment is already exists");
      return;
    }

    if (
      formData.visitorMobile == responseGroup.data.visitorMobile &&
      formData.firstName !== responseGroup.data.groupLeaderName
    ) {
      setPopupVisible(true);
      return;
    }

    const formattedData = {
      ...formData,
      meetingFrom: toLocalISOString(new Date(formData.meetingFrom)),
      meetingTo: toLocalISOString(new Date(formData.meetingTo)),
    };
    sessionStorage.setItem("savedFormData", JSON.stringify(formData));

    console.log("Form data:", formData);
    console.log("Form data:", formattedData);

    const formattedEmails = selectedEmails.join(", ");
    console.log("Submitting Emails:", formattedEmails);

    const formDataAdditional = {
      repeatVisit: isChecked,
      recurrencePattern: recurrencePatternAPI,
      selectedRecurrence: String(newSelectedRecurrencePattern),
      selectedDay: selectedDay,
      selectedWeekday: selectedWeekdayAPI,
      selectedMonth: selectedMonthAPI,
      recurEvery: recurEvery,
      isAllDay: isAllDayChecked,
      blockCalendar: isBlockCalenderChecked,
      assistanceRequired: isAssistanceRequired,
      serviceProviderAccess: isServiceProviderAccess,
      wifiRequired: isWiFiRequired,
      escortRequired: isEscortRequired,
      additionalNotification: isadditionalNotify,
      isOnBehalfOf: isbehalfNotify || false,
      onBehalfEmployeeId: onBehalfEmployeeId,
      additionalMessage: additionalMessage,
      checkInInstructions: checkInInstructions,
      notifyTo: formattedEmails,
    };

    // Log the object to the console
    console.log("Form Data formDataAdditional:", formDataAdditional);

    if (!valid) {
      setFormErrors(errors);
      toast.error("please fill all fields");
      console.log("Form has errors:", errors);
    } else {
      console.log("Form data:", formData);
      if (formData.visitorMobile) {
        const blackListCheck = await axios.get(
          `/BlackList/${formattedMobileNumber}`,
        );
        setBlackData(blackListCheck.data);
      }
      if (blackData) {
        toast.error("Person with this mobile number is blacklisted");
        return;
        // Show the popup when the icon is clicked
      }
      // else if (isCheckedP && isCheckedC) {
      //   navigate('/layout/group-appoinment-details', { state: { formattedData, formDataAdditional } });

      // }
      else {
        const empID = localStorage.getItem("employeeId");
        const addformData = formDataAdditional;
        const formatDateForApi = (date) => {
          return moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        };
        const getPhotoFromProfileImage = (profileImage) => {
          return profileImage ? profileImage.split(",")[1] : "";
        };
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        const checkInDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        if (addformData.repeatVisit == 1) {
          const requestData = [
            {
              id: 0,
              groupLeaderName: formData.firstName,
              visitorMobile: formData.visitorMobile,
              // visitorCompany: formData.company,
              visitorEmail: formData.visitorEmail,
              appointmentStatus: "Scheduled",
              createdBy: Number(empID),
              createdDate: toLocalISOString(new Date(formData.meetingFrom)),
              modifiedBy: Number(empID),
              modifiedDate: checkInDateTime,
              appointmentDate: toLocalISOString(new Date(formData.meetingFrom)),
              meetingVenue: formData.meetingVenue,
              idProofType: formData.selectedIdProofTypeId || 0,
              idProofNo: formData.idProofNo,
              validTill: toLocalISOString(new Date(formData.meetingTo)),
              selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
              txtManagersID: "",
              // photo: formData.visitorPhoto,
              txtFloor: "",
              txtMeetingRoom: "",
              txtCostCenter: "",
              gate: formData.gate,
              building: formData.building,
              purpose: formData.purpose,
              assitanceRequired: addformData.assistanceRequired,
              serviceProviderAccess: addformData.serviceProviderAccess,
              wifiRequired: addformData.wifiRequired,
              escort: addformData.escortRequired,
              additionalNotification: addformData.additionalNotification,
              isOnBehalfOf: addformData.isOnBehalfOf,
              onBehalfEmployeeId: addformData.onBehalfEmployeeId,
              notifyTo: addformData.notifyTo,
              messageToVisitor: addformData.additionalMessage,
              checkinInstruction: addformData.checkInInstructions,
              allDay: addformData.isAllDay,
              blockCalendar: addformData.blockCalendar,
              repeatVisit: addformData.repeatVisit,
              recurrancePattern: addformData.recurrencePattern,
              recurEvery: parseInt(addformData.recurEvery, 10),
              selectedRecurrence: addformData.selectedRecurrence,
              country: "India",
              firstName: formData.firstName,
              middleName: formData.middleName,
              lastName: formData.lastName,
              nationality: formData.nationality,
              gender: formData.gender,
              visitorCompany: "",
              allowMultipleAppointment: true,
              photo: "",
              idProofName: "",
            },
          ];

          console.log("Request Data:", requestData);
          try {
            const response = await axios.post(
              "/GroupAppointment/GroupAppointment",
              requestData,
            );
            console.log("response", response);

            if (response.data == "-1") {
              toast.error("appointment already exists");
              // return
            }
            if (response.status === 200) {
              toast.success(
                "Form Submitted successfully Please check the Email for Appointment!",
              );
              console.log("response", response);
              console.log("response", response.data);

              const appId = response.data;

              navigate("/layout/group-appoinment-details", {
                state: {
                  appId, // Pass it here
                  formattedData,
                  formDataAdditional,
                },
              });

              // Delay navigation to ensure the toast is displayed

              // Handle the response data, e.g., display details or update state
            }
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        } else {
          const requestData = [
            {
              id: 0,
              groupLeaderName: formData.firstName,
              visitorMobile: formData.visitorMobile,
              // visitorCompany: formData.company,
              visitorEmail: formData.visitorEmail,
              appointmentStatus: "Scheduled",
              createdBy: Number(empID),
              createdDate: formatDateForApi(formData.meetingFrom),
              modifiedBy: Number(empID),
              modifiedDate: checkInDateTime,
              appointmentDate: formatDateForApi(formData.meetingFrom),
              meetingVenue: formData.meetingVenue,
              idProofType: formData.selectedIdProofTypeId || 0,
              idProofNo: formData.idProofNo,
              validTill: formatDateForApi(formData.meetingTo),
              selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
              txtManagersID: "",
              // photo: formData.visitorPhoto,
              txtFloor: "",
              txtMeetingRoom: "",
              txtCostCenter: "",
              gate: formData.gate,
              building: formData.building,
              purpose: formData.purpose,
              assitanceRequired: addformData.assistanceRequired,
              serviceProviderAccess: addformData.serviceProviderAccess,
              wifiRequired: addformData.wifiRequired,
              escort: addformData.escortRequired,
              additionalNotification: addformData.additionalNotification,
              isOnBehalfOf: addformData.isOnBehalfOf,
              onBehalfEmployeeId: addformData.onBehalfEmployeeId,
              notifyTo: addformData.notifyTo,
              messageToVisitor: addformData.additionalMessage,
              checkinInstruction: addformData.checkInInstructions,
              country: "",
              allDay: addformData.isAllDay,
              blockCalendar: addformData.blockCalendar,
              firstName: formData.firstName,
              middleName: formData.middleName,
              lastName: formData.lastName,
              nationality: formData.nationality,
              gender: formData.gender,
              visitorCompany: "",
              photo: "",
              allowMultipleAppointment: true,
              idProofName: "",
            },
          ];

          console.log("Request Data:", requestData);
          try {
            const response = await axios.post(
              "/GroupAppointment/GroupAppointment",
              requestData,
            );
            console.log("response", response);
            if (response.data == "-1") {
              toast.error("appointment already exists");
              // return
            }
            if (response.status === 200) {
              toast.success(
                "Form Submitted successfully Please check the Email for Appointment!",
              );

              // Delay navigation to ensure the toast is displayed
              console.log("response", response);
              console.log("response", response.data);

              const appId = response.data;

              navigate("/layout/group-appoinment-details", {
                state: {
                  appId, // Pass it here
                  formattedData,
                  formDataAdditional,
                },
              }); // Adjust the delay as needed (3000ms = 3 seconds)
            }
          } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Something went wrong. Please try again.");
          }
        }

        // toast.error('Please verify the privacy and covid fitness')
      }
    }
    // setIsChecked(false);
    // setRecurrencePattern(''); // Set to default value (1 for Daily)
    // setSelectedDay('');
    // setSelectedWeekday('');
    // setSelectedMonth('');
    // setRecurEvery('');
    // setIsAllDayChecked(false);
    // setIsAssistanceRequired(false);
    // setIsServiceProviderAccess(false);
    // setIsWiFiRequired(false);
    // setIsEscortRequired(false);
    // setAdditionalMessage('');
    // setCheckInInstructions('');
    // setIsAdditionalNotify('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const webcamRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Take photo");
  const [profileImage, setProfileImage] = useState(null);

  const handleCapture = async () => {
    if (!isCameraOn) {
      // Turn on the camera
      setIsCameraOn(true);
      setButtonLabel("Capture");
    } else {
      // Capture the webcam image
      const imageSrc = webcamRef.current.getScreenshot();
      console.log("Captured Image:", imageSrc);

      if (imageSrc) {
        // Create an image element from the captured image
        const img = new Image();
        img.src = imageSrc;

        img.onload = async () => {
          // Create a canvas for image processing
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");

          // Draw the captured image on the canvas
          ctx.drawImage(img, 0, 0, img.width, img.height);

          // Initialize MediaPipe Selfie Segmentation
          const segmentation = new SelfieSegmentation({
            locateFile: (file) =>
              `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
          });

          segmentation.setOptions({
            modelSelection: 1, // General-purpose face segmentation model
          });

          // Perform segmentation
          await segmentation.initialize();
          const results = await new Promise((resolve) => {
            segmentation.onResults(resolve);
            segmentation.send({ image: img });
          });

          // Create a canvas for output
          const outputCanvas = document.createElement("canvas");
          outputCanvas.width = img.width;
          outputCanvas.height = img.height;
          const outputCtx = outputCanvas.getContext("2d");

          // Draw the original image
          outputCtx.drawImage(img, 0, 0, img.width, img.height);

          // Apply the segmentation mask
          outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
          outputCtx.drawImage(
            results.segmentationMask,
            0,
            0,
            img.width,
            img.height,
          );

          // Reset the operation and apply a transparent background
          outputCtx.globalCompositeOperation = "destination-over";
          outputCtx.fillStyle = "transparent"; // Transparent background
          outputCtx.fillRect(0, 0, img.width, img.height);

          // Convert the processed image to Base64
          const base64Image = outputCanvas.toDataURL("image/png");

          // Set the profile image and form data
          setProfileImage(base64Image); // Display the processed image
          setFormData((prevData) => ({
            ...prevData,
            visitorPhoto: base64Image.split(",")[1], // Store Base64 (excluding metadata)
          }));

          console.log("Processed Image (Base64):", base64Image);
        };
      }

      // Turn off the camera and reset the button label
      setIsCameraOn(false);
      setButtonLabel("Take photo");
    }
  };

  // Function to handle image upload from the file input
  const handleImageUpload = async (e) => {
    const file = e.target.files[0]; // Get the uploaded file
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = async () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = async () => {
        // Create a canvas for image processing
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");

        // Draw the uploaded image on the canvas
        ctx.drawImage(img, 0, 0, img.width, img.height);

        // Initialize MediaPipe Selfie Segmentation
        const segmentation = new SelfieSegmentation({
          locateFile: (file) =>
            `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
        });

        segmentation.setOptions({
          modelSelection: 1, // General-purpose face segmentation model
        });

        // Perform segmentation
        await segmentation.initialize();
        const results = await new Promise((resolve) => {
          segmentation.onResults(resolve);
          segmentation.send({ image: img });
        });

        // Create a canvas for output
        const outputCanvas = document.createElement("canvas");
        outputCanvas.width = img.width;
        outputCanvas.height = img.height;
        const outputCtx = outputCanvas.getContext("2d");

        // Draw the original image
        outputCtx.drawImage(img, 0, 0, img.width, img.height);

        // Apply the segmentation mask
        outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
        outputCtx.drawImage(
          results.segmentationMask,
          0,
          0,
          img.width,
          img.height,
        );

        // Reset the operation and apply a transparent background
        outputCtx.globalCompositeOperation = "destination-over";
        outputCtx.fillStyle = "transparent"; // Transparent background
        outputCtx.fillRect(0, 0, img.width, img.height);

        // Convert the processed image to Base64
        const base64Image = outputCanvas.toDataURL("image/png");

        // Update the processed image in state and form data
        setProfileImage(base64Image); // Display the processed image
        setFormData({ ...formData, visitorPhoto: base64Image.split(",")[1] });
        console.log("base64Image", base64Image.split(",")[1]);
        // Save Base64 (excluding metadata)
      };
    };

    reader.readAsDataURL(file); // Read the file as base64
  };

  const [isPopupVisiblePrivacy, setPopupVisiblePrivacy] = useState(false);
  const [isPopupVisibleCovid, setPopupVisibleCovid] = useState(false);
  const [isCheckedB, setIsCheckedB] = useState(false);
  const [isCheckedP, setIsCheckedP] = useState(false);
  const [isCheckedC, setIsCheckedC] = useState(false);

  const handlePrivacyLinkClickPrivacy = () => {
    setPopupVisiblePrivacy(true);
  };

  const handleClosePopupPrivacy = () => {
    setPopupVisiblePrivacy(false);
  };

  const handlePrivacyLinkClickCovid = () => {
    setPopupVisibleCovid(true);
  };

  const handleClosePopupCovid = () => {
    setPopupVisibleCovid(false);
  };
  const handleCheckboxChangeB = (event) => {
    setIsCheckedB(event.target.checked);
  };
  const handleCheckboxChangeP = (event) => {
    setIsCheckedP(event.target.checked);
  };
  const handleCheckboxChangeC = (event) => {
    setIsCheckedC(event.target.checked);
  };

  const onClose = async (event) => {
    event.preventDefault();
    let valid = true;
    const errors = {};

    // if (formData.groupLeaderName === '') {
    //   errors.groupLeaderName = true;
    //   valid = false;
    // }
    if (fieldData.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    // if (fieldData.visitorCompanyField && formData.company === '') {
    //   errors.company = true;
    //   valid = false;
    // }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (fieldData.meetingOnField && formData.meetingFrom === null) {
      errors.meetingFrom = true;
      valid = false;
    }
    if (fieldData.meetingToField && formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (fieldData.locationField && formData.meetingVenue === "") {
      errors.meetingVenue = true;
      valid = false;
    }
    if (fieldData.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData.idProofTypeField && formData.selectedIdProofTypeId === "") {
      errors.selectedIdProofTypeId = true;
      valid = false;
    }
    if (fieldData.idProofNumberField && formData.idProofNo === "") {
      errors.idProofNo = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    if (fieldData.visitorNameField && formData.visitorMobile === null) {
      errors.visitorMobile = true;
      valid = false;
    }
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
      }
    }

    if (!validateMeetingTimes()) {
      valid = false;
    }

    setFormErrors(errors);
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localDate = new Date(date - tzOffset); // Apply the offset to get local time
      return localDate.toISOString().slice(0, -1); // Remove the 'Z' from the ISO string
    };
    localStorage.setItem("formData", JSON.stringify(formData)); // Save form data in local storage
    setFormData({
      firstName: existingData.groupLeaderName,
    });
    console.log("formData", formData);
    console.log("existingData.groupLeaderName", existingData.groupLeaderName);

    const formattedData = {
      ...formData,
      firstName: existingData.groupLeaderName,
      meetingFrom: toLocalISOString(new Date(formData.meetingFrom)),
      meetingTo: toLocalISOString(new Date(formData.meetingTo)),
      isAllDay: isAllDayChecked,
      blockCalendar: isBlockCalenderChecked,
    };
    console.log("Form data:", formData);
    console.log("Form data:", formattedData);
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }

    // Log the new selected recurrence pattern before setting the state
    console.log(
      "Selected Recurrence Pattern before update:",
      newSelectedRecurrencePattern,
    );
    const formattedEmails = selectedEmails.join(", ");
    console.log("Submitting Emails:", formattedEmails);
    const formDataAdditional = {
      repeatVisit: isChecked,
      recurrencePattern: recurrencePatternAPI,
      selectedRecurrence: String(newSelectedRecurrencePattern),
      selectedDay: selectedDay,
      selectedWeekday: selectedWeekdayAPI,
      selectedMonth: selectedMonthAPI,
      recurEvery: recurEvery,
      isAllDay: isAllDayChecked,
      blockCalendar: isBlockCalenderChecked,
      assistanceRequired: isAssistanceRequired,
      serviceProviderAccess: isServiceProviderAccess,
      wifiRequired: isWiFiRequired,
      escortRequired: isEscortRequired,
      additionalNotification: isadditionalNotify,
      isOnBehalfOf: isbehalfNotify || false,
      onBehalfEmployeeId: onBehalfEmployeeId,
      additionalMessage: additionalMessage,
      checkInInstructions: checkInInstructions,
      notifyTo: formattedEmails,
    };

    // Log the object to the console
    console.log("Form Data formDataAdditional:", formDataAdditional);

    if (!valid) {
      setFormErrors(errors);
      toast.error("please fill all fields");
      console.log("Form has errors:", errors);
    } else {
      const formattedMobileNumber = `${defaultCode}-${formData.visitorMobile}`;
      console.log("Form data:", formData);
      if (formData.visitorMobile) {
        const blackListCheck = await axios.get(
          `/BlackList/${formattedMobileNumber}`,
        );
        setBlackData(blackListCheck.data);
      }
      if (blackData) {
        toast.error("Person with this mobile number is blacklisted");
        // Show the popup when the icon is clicked
      }
      // else if (isCheckedP && isCheckedC) {
      //   navigate('/layout/group-appoinment-details', { state: { formattedData, formDataAdditional } });
      //   setPopupVisible(false);
      // }
      else {
        const empID = localStorage.getItem("employeeId");
        const addformData = formDataAdditional;
        const formatDateForApi = (date) => {
          return moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        };
        const getPhotoFromProfileImage = (profileImage) => {
          return profileImage ? profileImage.split(",")[1] : "";
        };
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        const checkInDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        if (addformData.repeatVisit == 1) {
          const requestData = [
            {
              groupLeaderName: formData.firstName,
              visitorMobile: formData.visitorMobile,
              // visitorCompany: formData.company,
              visitorEmail: formData.visitorEmail,
              appointmentStatus: "Scheduled",
              createdBy: Number(empID),
              createdDate: toLocalISOString(new Date(formData.meetingFrom)),
              modifiedBy: Number(empID),
              modifiedDate: checkInDateTime,
              appointmentDate: toLocalISOString(new Date(formData.meetingFrom)),
              meetingVenue: formData.meetingVenue,
              idProofType: formData.selectedIdProofTypeId || 0,
              idProofNo: formData.idProofNo,
              validTill: toLocalISOString(new Date(formData.meetingTo)),
              selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
              txtManagersID: "",
              // photo: formData.visitorPhoto,
              txtFloor: "",
              txtMeetingRoom: "",
              txtCostCenter: "",
              gate: formData.gate,
              building: formData.building,
              purpose: formData.purpose,
              assitanceRequired: addformData.assistanceRequired,
              serviceProviderAccess: addformData.serviceProviderAccess,
              wifiRequired: addformData.wifiRequired,
              escort: addformData.escortRequired,
              additionalNotification: addformData.additionalNotification,
              isOnBehalfOf: addformData.isOnBehalfOf,
              onBehalfEmployeeId: addformData.onBehalfEmployeeId,
              notifyTo: addformData.notifyTo,
              messageToVisitor: addformData.additionalMessage,
              checkinInstruction: addformData.checkInInstructions,
              allDay: addformData.isAllDay,
              blockCalendar: addformData.blockCalendar,
              repeatVisit: addformData.repeatVisit,
              recurrancePattern: addformData.recurrencePattern,
              recurEvery: parseInt(addformData.recurEvery, 10),
              selectedRecurrence: addformData.selectedRecurrence,
              country: "India",
              firstName: formData.firstName,
              middleName: formData.middleName,
              lastName: formData.lastName,
              nationality: formData.nationality,
              gender: formData.gender,
              visitorCompany: "",
              photo: "",
              allowMultipleAppointment: true,
            },
          ];

          console.log("Request Data:", requestData);
          try {
            const response = await axios.post(
              "/GroupAppointment/GroupAppointment",
              requestData,
            );
            console.log("response", response);
            if (response.data == "-1") {
              toast.error("appointment already exists");
              // return
            }
            if (response.status === 200) {
              toast.success(
                "Form Submitted successfully Please check the Email for Appointment!",
              );

              // Delay navigation to ensure the toast is displayed
              console.log("response", response);
              console.log("response", response.data);

              const appId = response.data;

              navigate("/layout/group-appoinment-details", {
                state: {
                  appId, // Pass it here
                  formattedData,
                  formDataAdditional,
                },
              });
              // Handle the response data, e.g., display details or update state
            }
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        } else {
          const requestData = [
            {
              groupLeaderName: formData.firstName,
              visitorMobile: formData.visitorMobile,
              // visitorCompany: formData.company,
              visitorEmail: formData.visitorEmail,
              appointmentStatus: "Scheduled",
              createdBy: Number(empID),
              createdDate: formatDateForApi(formData.meetingFrom),
              modifiedBy: Number(empID),
              modifiedDate: checkInDateTime,
              appointmentDate: formatDateForApi(formData.meetingFrom),
              meetingVenue: formData.meetingVenue,
              idProofType: formData.selectedIdProofTypeId || 0,
              idProofNo: formData.idProofNo,
              validTill: formatDateForApi(formData.meetingTo),
              selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
              txtManagersID: "null",
              // photo: formData.visitorPhoto,
              txtFloor: "null",
              txtMeetingRoom: "null",
              txtCostCenter: "null",
              gate: formData.gate,
              building: formData.building,
              purpose: formData.purpose,
              assitanceRequired: addformData.assistanceRequired,
              serviceProviderAccess: addformData.serviceProviderAccess,
              wifiRequired: addformData.wifiRequired,
              escort: addformData.escortRequired,
              additionalNotification: addformData.additionalNotification,
              isOnBehalfOf: addformData.isOnBehalfOf,
              onBehalfEmployeeId: addformData.onBehalfEmployeeId,
              notifyTo: addformData.notifyTo,
              messageToVisitor: addformData.additionalMessage,
              checkinInstruction: addformData.checkInInstructions,
              country: "",
              allDay: addformData.isAllDay,
              blockCalendar: addformData.blockCalendar,
              firstName: formData.firstName,
              middleName: formData.middleName,
              lastName: formData.lastName,
              nationality: formData.nationality,
              gender: formData.gender,
              visitorCompany: "",
              photo: "",
              allowMultipleAppointment: true,
            },
          ];

          console.log("Request Data:", requestData);
          try {
            const response = await axios.post(
              "/GroupAppointment/GroupAppointment",
              requestData,
            );
            console.log("response", response);
            if (response.data == "-1") {
              toast.error("appointment already exists");
              // return
            }
            if (response.status === 200) {
              toast.success(
                "Form Submitted successfully Please check the Email for Appointment!",
              );

              // Delay navigation to ensure the toast is displayed
              console.log("response", response);
              console.log("response", response.data);

              const appId = response.data;

              navigate("/layout/group-appoinment-details", {
                state: {
                  appId, // Pass it here
                  formattedData,
                  formDataAdditional,
                },
              });
            }
          } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Something went wrong. Please try again.");
          }
        }

        // toast.error('Please verify the privacy and covid fitness')
      }
    }
  };
  const onConfirm = async (event) => {
    event.preventDefault();
    let valid = true;
    const errors = {};

    // if (formData.groupLeaderName === '') {
    //   errors.groupLeaderName = true;
    //   valid = false;
    // }
    if (fieldData.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    // if (fieldData.visitorCompanyField && formData.company === '') {
    //   errors.company = true;
    //   valid = false;
    // }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (fieldData.meetingOnField && formData.meetingFrom === null) {
      errors.meetingFrom = true;
      valid = false;
    }
    if (fieldData.meetingToField && formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (fieldData.locationField && formData.meetingVenue === "") {
      errors.meetingVenue = true;
      valid = false;
    }
    if (fieldData.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData.idProofTypeField && formData.selectedIdProofTypeId === "") {
      errors.selectedIdProofTypeId = true;
      valid = false;
    }
    if (fieldData.idProofNumberField && formData.idProofNo === "") {
      errors.idProofNo = true;
      valid = false;
    }

    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    if (fieldData.visitorNameField && formData.visitorMobile === null) {
      errors.visitorMobile = true;
      valid = false;
    }
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
        return;
      }
    }

    if (!validateMeetingTimes()) {
      valid = false;
    }

    setFormErrors(errors);
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localDate = new Date(date - tzOffset); // Apply the offset to get local time
      return localDate.toISOString().slice(0, -1); // Remove the 'Z' from the ISO string
    };
    localStorage.setItem("formData", JSON.stringify(formData)); // Save form data in local storage
    const formattedData = {
      ...formData,
      meetingFrom: toLocalISOString(new Date(formData.meetingFrom)),
      meetingTo: toLocalISOString(new Date(formData.meetingTo)),
      isAllDay: isAllDayChecked,
      blockCalendar: isBlockCalenderChecked,
    };
    console.log("Form data:", formData);
    console.log("Form data:", formattedData);
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }

    // Log the new selected recurrence pattern before setting the state
    console.log(
      "Selected Recurrence Pattern before update:",
      newSelectedRecurrencePattern,
    );
    const formattedEmails = selectedEmails.join(", ");
    console.log("Submitting Emails:", formattedEmails);
    const formDataAdditional = {
      repeatVisit: isChecked,
      recurrencePattern: recurrencePatternAPI,
      selectedRecurrence: String(newSelectedRecurrencePattern),
      selectedDay: selectedDay,
      selectedWeekday: selectedWeekdayAPI,
      selectedMonth: selectedMonthAPI,
      recurEvery: recurEvery,
      isAllDay: isAllDayChecked,
      blockCalendar: isBlockCalenderChecked,
      assistanceRequired: isAssistanceRequired,
      serviceProviderAccess: isServiceProviderAccess,
      wifiRequired: isWiFiRequired,
      escortRequired: isEscortRequired,
      additionalNotification: isadditionalNotify,
      isOnBehalfOf: isbehalfNotify || false,
      onBehalfEmployeeId: onBehalfEmployeeId,
      notifyTo: formattedEmails,
      additionalMessage: additionalMessage,
      checkInInstructions: checkInInstructions,
    };

    // Log the object to the console
    console.log("Form Data formDataAdditional:", formDataAdditional);
    const formattedMobileNumber = `${defaultCode}-${formData.visitorMobile}`;
    if (!valid) {
      setFormErrors(errors);
      toast.error("please fill all fields");
      console.log("Form has errors:", errors);
    } else {
      console.log("Form data:", formData);
      if (formData.visitorMobile) {
        const blackListCheck = await axios.get(
          `/BlackList/${formattedMobileNumber}`,
        );
        setBlackData(blackListCheck.data);
      }
      if (blackData) {
        toast.error("Person with this mobile number is blacklisted");
        return;
        // Show the popup when the icon is clicked
      }
      // else if (isCheckedP && isCheckedC) {
      //   navigate('/layout/group-appoinment-details', { state: { formattedData, formDataAdditional } });

      // }
      else {
        const empID = localStorage.getItem("employeeId");
        const addformData = formDataAdditional;
        const formatDateForApi = (date) => {
          return moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        };
        const getPhotoFromProfileImage = (profileImage) => {
          return profileImage ? profileImage.split(",")[1] : "";
        };
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        const checkInDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        if (addformData.repeatVisit == 1) {
          const requestData = [
            {
              groupLeaderName: formData.firstName,
              visitorMobile: formData.visitorMobile,
              // visitorCompany: formData.company,
              visitorEmail: formData.visitorEmail,
              appointmentStatus: "Scheduled",
              createdBy: Number(empID),
              createdDate: toLocalISOString(new Date(formData.meetingFrom)),
              modifiedBy: Number(empID),
              modifiedDate: checkInDateTime,
              appointmentDate: toLocalISOString(new Date(formData.meetingFrom)),
              meetingVenue: formData.meetingVenue,
              idProofType: formData.selectedIdProofTypeId || 0,
              idProofNo: formData.idProofNo,
              validTill: formatDateForApi(formData.meetingTo),
              selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
              txtManagersID: "null",
              // photo: formData.visitorPhoto,
              txtFloor: "null",
              txtMeetingRoom: "null",
              txtCostCenter: "null",
              gate: formData.gate,
              building: formData.building,
              purpose: formData.purpose,
              assitanceRequired: addformData.assistanceRequired,
              serviceProviderAccess: addformData.serviceProviderAccess,
              wifiRequired: addformData.wifiRequired,
              escort: addformData.escortRequired,
              additionalNotification: addformData.additionalNotification,
              isOnBehalfOf: addformData.isOnBehalfOf,
              onBehalfEmployeeId: addformData.onBehalfEmployeeId,
              notifyTo: addformData.notifyTo,
              messageToVisitor: addformData.additionalMessage,
              checkinInstruction: addformData.checkInInstructions,
              allDay: addformData.isAllDay,
              blockCalendar: addformData.blockCalendar,
              repeatVisit: addformData.repeatVisit,
              recurrancePattern: addformData.recurrencePattern,
              recurEvery: parseInt(addformData.recurEvery, 10),
              selectedRecurrence: addformData.selectedRecurrence,
              country: "India",
              firstName: formData.firstName,
              middleName: formData.middleName,
              lastName: formData.lastName,
              nationality: formData.nationality,
              gender: formData.gender,
              visitorCompany: "",
              photo: "",
              allowMultipleAppointment: true,
            },
          ];

          console.log("Request Data:", requestData);
          try {
            const response = await axios.post(
              "/GroupAppointment/GroupAppointment",
              requestData,
            );
            console.log("response", response);
            if (response.data == "-1") {
              toast.error("appointment already exists");
              // return
            }
            if (response.status === 200) {
              toast.success(
                "Form Submitted successfully Please check the Email for Appointment!",
              );

              // Delay navigation to ensure the toast is displayed
              console.log("response", response);
              console.log("response", response.data);

              const appId = response.data;

              navigate("/layout/group-appoinment-details", {
                state: {
                  appId, // Pass it here
                  formattedData,
                  formDataAdditional,
                },
              });
              // Handle the response data, e.g., display details or update state
            }
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        } else {
          const requestData = [
            {
              groupLeaderName: formData.firstName,
              visitorMobile: formData.visitorMobile,
              // visitorCompany: formData.company,
              visitorEmail: formData.visitorEmail,
              appointmentStatus: "Scheduled",
              createdBy: Number(empID),
              createdDate: formatDateForApi(formData.meetingFrom),
              modifiedBy: Number(empID),
              modifiedDate: checkInDateTime,
              appointmentDate: formatDateForApi(formData.meetingFrom),
              meetingVenue: formData.meetingVenue,
              idProofType: formData.selectedIdProofTypeId || 0,
              idProofNo: formData.idProofNo,
              validTill: formatDateForApi(formData.meetingTo),
              selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
              txtManagersID: "null",
              // photo: formData.visitorPhoto,
              txtFloor: "null",
              txtMeetingRoom: "null",
              txtCostCenter: "null",
              gate: formData.gate,
              building: formData.building,
              purpose: formData.purpose,
              assitanceRequired: addformData.assistanceRequired,
              serviceProviderAccess: addformData.serviceProviderAccess,
              wifiRequired: addformData.wifiRequired,
              escort: addformData.escortRequired,
              additionalNotification: addformData.additionalNotification,
              isOnBehalfOf: addformData.isOnBehalfOf,
              onBehalfEmployeeId: addformData.onBehalfEmployeeId,
              notifyTo: addformData.notifyTo,
              messageToVisitor: addformData.additionalMessage,
              checkinInstruction: addformData.checkInInstructions,
              country: "",
              allDay: addformData.isAllDay,
              blockCalendar: addformData.blockCalendar,
              firstName: formData.firstName,
              middleName: formData.middleName,
              lastName: formData.lastName,
              nationality: formData.nationality,
              gender: formData.gender,
              visitorCompany: "",
              photo: "",
              allowMultipleAppointment: true,
            },
          ];

          console.log("Request Data:", requestData);
          try {
            const response = await axios.post(
              "/GroupAppointment/GroupAppointment",
              requestData,
            );
            console.log("response", response);
            if (response.data == "-1") {
              toast.error("appointment already exists");
              // return
            }
            if (response.status === 200) {
              toast.success(
                "Form Submitted successfully Please check the Email for Appointment!",
              );

              // Delay navigation to ensure the toast is displayed
              console.log("response", response);
              console.log("response", response.data);

              const appId = response.data;

              navigate("/layout/group-appoinment-details", {
                state: {
                  appId, // Pass it here
                  formattedData,
                  formDataAdditional,
                },
              });
            }
          } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Something went wrong. Please try again.");
          }
        }

        // toast.error('Please verify the privacy and covid fitness')
      }
    }
  };

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleFirstNameChange = async (e) => {
    const { value } = e.target;

    // Allow only alphabets and spaces
    if (!/^[A-Za-z\s]*$/.test(value)) return;

    setFormData((prev) => ({ ...prev, firstName: value }));

    // Clear error if present
    if (formErrors.firstName) {
      setFormErrors((prev) => ({ ...prev, firstName: false }));
    }
    const visitorTypeId = formData.selectedVisitorTypeId; // ✅ make sure this persists after reset

    if (value.length >= 3 && visitorTypeId) {
      try {
        const response = await axios.get(
          `GroupAppointment/GetGroupAppointmentDetailsForGroupLeaderNameAndVisitorTypeId`,
          {
            params: {
              GroupLeaderName: value,
              visitorTypeId: visitorTypeId,
            },
          },
        );
        setSuggestions(response.data || []);
        setShowSuggestions(true);
      } catch (error) {
        console.error("API error:", error);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClickF = async (item) => {
    try {
      const matchedNationality = nationalityList.find(
        (nat) => nat.id === item.nationalityId,
      );

      const matchMeetingVenu = meetingvenues.find(
        (venue) => venue.locationName === item.meetingVenue,
      );

      if (!matchMeetingVenu) {
        console.error(
          "No matching meeting venue found for:",
          item.meetingVenue,
        );
        return; // or handle the error accordingly
      }

      const menuNameResponse = await axiosInstance.get(
        `/Location/GetGatesByLocationID?locationID=${matchMeetingVenu.id}`,
      );
      setGates(menuNameResponse.data);

      const selectedGateObject = menuNameResponse.data.find(
        (gate) => gate.id === item.gateId,
      );
      setSelectedGate(selectedGateObject);

      if (selectedGateObject) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          gate: selectedGateObject.name,
        }));

        // const buildings = await fetchBuildingsByGate(selectedGateObject.id);
        const buildingsResponse = await axiosInstance.get(
          `/Location/GetBuildingAndGateByLocationId/${matchMeetingVenu.id}`,
        );
        const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
        setBuildings(fetchedBuildings);

        const matchedBuilding = fetchedBuildings.find(
          (bld) => bld.name === item.building,
        );

        // Other state setters
        setIsAllDayChecked(item.allDay);
        setIsBlockCalenderChecked(item.blockCalendar);
        setIsAssistanceRequired(item.assitanceRequired);
        setIsServiceProviderAccess(item.serviceProviderAccess);
        setIsWiFiRequired(item.wifiRequired);
        setIsEscortRequired(item.escort);
        setAdditionalMessage(item.messageToVisitor);
        setCheckInInstructions(item.checkinInstruction);
        setIsAdditionalNotify(item.additionalNotification);
        setIsBehalfNotify(item.isOnBehalfOf);

        setFormData((prev) => ({
          ...prev,
          firstName: item.firstName,
          middleName: item.middleName || "",
          lastName: item.lastName || "",
          gender: item.gender || "",
          visitorEmail: item.visitorEmail || "",
          nationality: matchedNationality?.name || "",
          visitorMobile: item.visitorMobile || "",
          purpose: item.purpose || "",
          meetingVenue: item.meetingVenue || "",
          building: matchedBuilding?.name || "",
          idProofNo: item.idProofNo || "",
          selectedIdProofTypeId: item.idProofType || "",
        }));

        setDefaultCode(matchedNationality?.nationalityCode || "");
        setShowSuggestions(false);
      } else {
        console.warn("Selected gate object not found for gateId:", item.gateId);
      }

      console.log("Selected visitor data:", item);
    } catch (error) {
      console.error("Error in handleSuggestionClickF:", error);
    }
  };

  return (
    <Container>
      <Header>
        <Heading>Group Appointment</Heading>
        <ButtonGroup>
          <ResetButton onClick={handleReset}>Reset</ResetButton>
          <SubmitButton onClick={handleSubmit}>Next</SubmitButton>
        </ButtonGroup>
      </Header>
      <Tabs>
        <Tab
          active={activeTab === "details"}
          onClick={() => setActiveTab("details")}
        >
          Details
        </Tab>
        <Tab
          active={activeTab === "additional"}
          onClick={() => setActiveTab("additional")}
        >
          Additional
        </Tab>
      </Tabs>
      <TabContent active={activeTab === "details"}>
        <CardContainer>
          <Card>
            <FormGroup>
              <Label>
                Visitor Type
                <Asterisk> *</Asterisk>
              </Label>
              <Select
                name="selectedVisitorTypeId"
                value={formData.selectedVisitorTypeId}
                onChange={handleChangeNew}
                disabled
              >
                <option value="">Select type</option>
                {visitorTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.visitorTypeDesc}
                  </option>
                ))}
              </Select>
              {formErrors.selectedVisitorTypeId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a visitor type
                </span>
              )}
            </FormGroup>
            {/* <FormGroup>
              <Label>
                Visitor Company{fieldData.visitorCompanyField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="company"
                placeholder="Enter Company"
                value={formData.company}
                onChange={handleInputChange}
              />
              {formErrors.company && (
                <span style={{ color: 'red', fontSize: '12px' }}>Please fill in the company name</span>
              )}
            </FormGroup> */}
            {/* <FormGroup>
              <Label>
                Group Leader Name<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="groupLeaderName"
                value={formData.groupLeaderName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange(e); // Only update state if input is valid
                  }
                }}
                placeholder="Enter Group Leader Name"
                style={{
                  borderBottomColor: formErrors.groupLeaderName ? 'red' : '#2b3497',
                }}
              />
              {formErrors.groupLeaderName && (
                <span style={{ color: 'red', fontSize: '12px' }}>Please fill in the group leader name</span>
              )}
            </FormGroup> */}
            <FormRow>
              <FormGroup style={{ position: "relative" }}>
                <Label>
                  First Name
                  {fieldData.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleFirstNameChange}
                  placeholder="Enter First Name"
                  style={{
                    borderColor: formErrors.firstName ? "red" : "#2B3497",
                  }}
                  autoComplete="off"
                  onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                  onKeyDown={(e) => {
                    if (e.key === 'Escape') setShowSuggestions(false);
                  }}
                />
                {formErrors.firstName && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Please fill in the first name
                  </span>
                )}

                {/* Elegant Suggestions Dropdown */}
                {showSuggestions && suggestions.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      zIndex: 999,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {suggestions.map((item, index) => (
                      <div
                        key={index}
                        // onClick={() => handleSuggestionClickF(item)}
                        onMouseDown={(e) => {
                          e.preventDefault(); // Prevents onBlur from firing before selection
                          handleSuggestionClickF(item);
                        }}
                        style={{
                          padding: "10px 15px",
                          cursor: "pointer",
                          borderBottom:
                            index !== suggestions.length - 1
                              ? "1px solid #eee"
                              : "none",
                          transition: "background 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f0f4ff")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "#fff")
                        }
                      >
                        <span style={{ fontWeight: "500", color: "#293495" }}>
                          {item.firstName}
                        </span>
                        <span
                          style={{
                            color: "#666",
                            fontSize: "12px",
                            marginLeft: "8px",
                          }}
                        >
                          ({item.visitorCompany})
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </FormGroup>

              <FormGroup>
                <Label>Middle Name</Label>
                <Input
                  type="text"
                  name="middleName"
                  value={formData.middleName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regular expression to only allow alphabets and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Only update state if input is valid
                    }
                  }}
                  placeholder="Enter Middle Name (Optional)"
                  style={{ borderColor: "#2B3497" }}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Last Name
                  {fieldData.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regular expression to only allow alphabets and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Only update state if input is valid
                    }
                  }}
                  placeholder="Enter Last Name"
                  style={{
                    borderColor: formErrors.lastName ? "red" : "#2B3497",
                  }}
                />
                {formErrors.lastName && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Please fill in the last name
                  </span>
                )}
              </FormGroup>
            </FormRow>
            <FormGroup>
              <Label>
                Visitor Email
                {fieldData.visitorEmailField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="email"
                name="visitorEmail"
                value={formData.visitorEmail}
                placeholder="Enter Email"
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.visitorEmail
                    ? "red"
                    : "#2b3497",
                }}
              />
              {formErrors.visitorEmail && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formData.visitorEmail
                    ? "Invalid email format"
                    : "Please fill in the visitor email"}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Gender
                {fieldData.genderField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="other">Other</option>
              </Select>
              {formErrors.gender && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gender
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Nationality
                {fieldData.nationalityField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="nationality"
                value={formData.nationality}
                onChange={(e) => {
                  const selectedNationality = nationalityList.find(
                    (n) => n.name === e.target.value,
                  );
                  setFormData({
                    ...formData,
                    nationality: e.target.value,
                    visitorMobile: "",
                  });
                  setDefaultCode(selectedNationality.nationalityCode);
                }}
              >
                <option value="">Select Nationality</option>
                {nationalityList.map((nationality) => (
                  <option
                    key={nationality.id}
                    value={nationality.name}
                    disabled={nationality.isBlackListed}
                  >
                    {nationality.name}
                  </option>
                ))}
              </Select>
              {formErrors.nationality && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a nationality
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Mobile{" "}
                {fieldData.visitorMobileField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="visitorMobile"
                value={formData.visitorMobile}
                placeholder="Enter  mobile number"
                maxLength={defaultCode === "91" ? 10 : 15}
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.visitorMobile
                    ? "red"
                    : "#2b3497",
                }}
              />
              {formErrors.visitorMobile && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formData.visitorMobile
                    ? "Invalid mobile number"
                    : "Please fill in the mobile number"}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Location
                {fieldData.locationField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="meetingVenue"
                value={formData.meetingVenue} // Ensure this is correctly mapped
                onChange={handleChangeLo}
              >
                <option value="">Select Location</option>
                {meetingvenues.map((type) => (
                  <option key={type.locationName} value={type.locationName}>
                    {type.locationName}
                  </option>
                ))}
              </Select>
              {formErrors.meetingVenue && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting venue
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Gate
                {fieldData.gateField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gate"
                value={selectedGate ? selectedGate.id : ""}
                onChange={handleGateChange}
              >
                <option value="">Select Gate</option>
                {gates.map((gate) => (
                  <option key={gate.id} value={gate.id}>
                    {gate.name}
                  </option>
                ))}
              </Select>
              {formErrors.gate && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gate
                </span>
              )}
            </FormGroup>
          </Card>
          <Card>
            <FormGroup>
              <Label>
                Area
                {fieldData.areaField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="building"
                value={formData.building}
                onChange={handleChange}
              >
                <option value="">Select Area</option>
                {Array.isArray(buildings) &&
                  buildings.map((building) => (
                    <option key={building.id} value={building.name}>
                      {building.name}
                    </option>
                  ))}
              </Select>
              {formErrors.building && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a building
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Meeting On
                {fieldData.meetingOnField && <Asterisk> *</Asterisk>}
              </Label>
              <StyledDatePicker
                selected={
                  formData.meetingFrom instanceof Date
                    ? formData.meetingFrom
                    : null
                }
                onChange={(date) => handleDateChange(date, "meetingFrom")}
                showTimeSelect
                dateFormat="Pp"
                minDate={currentDateTime}
                filterTime={filterPassedTime}
                timeClassName={highlightTime}
                placeholderText="Select Meeting Start Date and Time"
              />
              {formErrors.meetingFrom && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting start time
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Meeting To
                {fieldData.meetingToField && <Asterisk> *</Asterisk>}
              </Label>
              <StyledDatePicker
                selected={
                  formData.meetingTo instanceof Date ? formData.meetingTo : null
                }
                onChange={(date) => handleDateChange(date, "meetingTo")}
                showTimeSelect
                dateFormat="Pp"
                minDate={formData.meetingFrom || currentDateTime} // Ensure meetingTo is after meetingFrom
                filterTime={filterPassedTime}
                timeClassName={highlightTime}
                placeholderText="Select Meeting End Date and Time"
              />
              {formErrors.meetingTo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting end time
                </span>
              )}
            </FormGroup>
            <AdditionalInputContainerN>
              <CheckboxContainer>
                <CheckboxLabel>All Day</CheckboxLabel>
                <Checkbox
                  type="checkbox"
                  checked={isAllDayChecked}
                  onChange={handleAllDayCheckboxChange}
                />
              </CheckboxContainer>
            </AdditionalInputContainerN>
            <AdditionalInputContainerN>
              <CheckboxContainer>
                <CheckboxLabel>Block calendar</CheckboxLabel>
                <Checkbox
                  type="checkbox"
                  checked={isBlockCalenderChecked}
                  onChange={handleBlockCalenderCheckboxChange}
                />
              </CheckboxContainer>
            </AdditionalInputContainerN>

            <FormGroup>
              <Label>
                Id Proof Type
                {fieldData.idProofTypeField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="selectedIdProofTypeId"
                value={formData.selectedIdProofTypeId}
                onChange={handleChange}
              >
                <option value="">Select ID Proof Type</option>
                {idProofTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.idProofDescription}
                  </option>
                ))}
              </Select>
              {formErrors.selectedIdProofTypeId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a Id Prood type
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Id Proof Number
                {fieldData.idProofNumberField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="idProofNo"
                maxLength={4}
                placeholder="Enter Id Proof Number"
                value={formData.idProofNo}
                onChange={(e) => {
                  const regex = /^[a-zA-Z0-9]*$/; // Allows only alphanumeric characters
                  if (regex.test(e.target.value)) {
                    handleInputChange(e); // Call the original handler if valid
                  }
                }}
              />
              {formErrors.idProofNo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please Fill the Id Proof Number
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Purpose
                {fieldData.purpose && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="purpose"
                value={formData.purpose}
                onChange={handleChange}
                placeholder="Enter Purpose"
              />
              {formErrors.purpose && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please fill in the purpose
                </span>
              )}
            </FormGroup>
          </Card>
          {/* <ProfileCard>
            <VisitorPhotoHeading>Visitor Photo</VisitorPhotoHeading>
            <ProfileText>(Only png images)</ProfileText>
            <Circle>
              <WebcamContainer>
                {isCameraOn && (
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/png"
                    width="100%"
                    height="100%"
                    videoConstraints={{
                      width: 200,
                      height: 200,
                      facingMode: 'user',
                    }}
                  />
                )}
                {!isCameraOn && profileImage && (
                  <img
                    src={profileImage}
                    alt="Profile"
                    style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                  />
                )}
                {!isCameraOn && !profileImage && (
                  <ProfileIcon>
                    <User size={40} />
                  </ProfileIcon>
                )}
              </WebcamContainer>
            </Circle>
            <ButtonRow>
              <PhotoButton onClick={handleCapture}>
                {buttonLabel}
              </PhotoButton>
            </ButtonRow>
            <ButtonRow>
              <ActionButton onChange={handleImageUpload}>
                <label htmlFor="upload-button" style={{ cursor: 'pointer' }}>
                  Upload images
                </label>
              </ActionButton>
            </ButtonRow>
            <input
              id="upload-button"
              type="file"
              accept="image/png"
              style={{ display: 'none' }}
              onChange={handleImageUpload}
            />

            <CheckboxRowContainer>
              <CheckboxContainer>
                <input type="checkbox" checked={isCheckedP} onChange={handleCheckboxChangeP} />
                <span>
                  <PrivacyLink onClick={handlePrivacyLinkClickPrivacy}>Privacy Policy<span style={{ color: 'red' }}> *</span></PrivacyLink>
                </span>
              </CheckboxContainer>
              <CheckboxContainer>
                <input type="checkbox" checked={isCheckedC} onChange={handleCheckboxChangeC} />
                <span>
                  <PrivacyLink onClick={handlePrivacyLinkClickCovid}>COVID Fitness<span style={{ color: 'red' }}> *</span></PrivacyLink>
                </span>
              </CheckboxContainer>
            </CheckboxRowContainer>
          </ProfileCard> */}
        </CardContainer>
      </TabContent>
      <TabContent active={activeTab === "additional"}>
        <CardContainer>
          <Card>
            <CheckboxContainer>
              <CheckboxLabel>Repeat Visit</CheckboxLabel>
              <Checkbox
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </CheckboxContainer>

            <HeaderN>Scheduler</HeaderN>

            <DropdownContainer>
              <DropdownLabel>Recurrence Pattern:</DropdownLabel>
              <StyledDropdown
                value={recurrencePattern}
                onChange={handleDropdownChange}
                disabled={!isChecked}
              >
                <option value="" disabled>
                  Select pattern
                </option>
                <option value="1">Daily</option>
                <option value="2">Weekly</option>
                <option value="3">Monthly</option>
              </StyledDropdown>
            </DropdownContainer>

            {/* Daily input for selecting the day */}
            {/* <InputContainer show={recurrencePattern === '1'}>
              <SpinnerInputLabel>Recur Every:</SpinnerInputLabel>
              <SpinnerInput type="number" min="1" max="31" value={selectedDay} disabled={!isChecked} onChange={handleDayChange} />
            </InputContainer> */}

            {/* Weekly dropdown for selecting the weekday */}
            <InputContainer show={recurrencePattern === "2"}>
              <DropdownLabel>Select Weekdays:</DropdownLabel>
              <CheckboxContainernew>
                {[
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ].map((day, index) => (
                  <CheckboxLabelnew key={index}>
                    <Checkbox
                      type="checkbox"
                      disabled={!isChecked}
                      checked={selectedWeekday.includes(index + 1)}
                      onChange={() => handleWeekdayCheckboxChange(index + 1)}
                    />
                    {day}
                  </CheckboxLabelnew>
                ))}
              </CheckboxContainernew>
            </InputContainer>

            {/* Monthly dropdown for selecting the month */}
            <InputContainer show={recurrencePattern === "3"}>
              <DropdownLabel>Select Months:</DropdownLabel>
              <CheckboxContainernew>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((month, index) => (
                  <CheckboxLabelnew key={index}>
                    <Checkbox
                      type="checkbox"
                      disabled={!isChecked}
                      checked={selectedMonth.includes(index + 1)}
                      onChange={() => handleMonthCheckboxChange(index + 1)}
                    />
                    {month}
                  </CheckboxLabelnew>
                ))}
              </CheckboxContainernew>
            </InputContainer>

            {/* All Day checkbox and Recur Every input */}
            <InputContainer
              show={
                recurrencePattern === "2" ||
                recurrencePattern === "3" ||
                recurrencePattern === "1"
              }
            >
              <SpinnerInputLabel>Recur Every:</SpinnerInputLabel>
              <RecurrenceInput
                type="number"
                min="0"
                value={recurEvery}
                disabled={!isChecked}
                onChange={handleRecurEveryChange}
                onKeyDown={handleRecurEveryKeyDown}
              />
            </InputContainer>

            {/* <AdditionalInputContainer show={recurrencePattern === '2' || recurrencePattern === '3'}>
              <CheckboxContainer>
                <CheckboxLabel>All Day</CheckboxLabel>
                <Checkbox type="checkbox" checked={isAllDayChecked} onChange={handleAllDayCheckboxChange} />
              </CheckboxContainer>
            </AdditionalInputContainer> */}
          </Card>
          <Card>
            <SwitchContainer>
              <SwitchRow>
                <SwitchLabel>Assistance Required</SwitchLabel>
                <Switch
                  isOn={isAssistanceRequired}
                  onClick={toggleAssistanceRequired}
                >
                  <SwitchSlider isOn={isAssistanceRequired} />
                  <SwitchText isOn={isAssistanceRequired}>
                    {isAssistanceRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>Service Provider Access</SwitchLabel>
                <Switch
                  isOn={isServiceProviderAccess}
                  onClick={toggleServiceProviderAccess}
                >
                  <SwitchSlider isOn={isServiceProviderAccess} />
                  <SwitchText isOn={isServiceProviderAccess}>
                    {isServiceProviderAccess ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>WiFi Required</SwitchLabel>
                <Switch isOn={isWiFiRequired} onClick={toggleWiFiRequired}>
                  <SwitchSlider isOn={isWiFiRequired} />
                  <SwitchText isOn={isWiFiRequired}>
                    {isWiFiRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>Escort Required</SwitchLabel>
                <Switch isOn={isEscortRequired} onClick={toggleEscortRequired}>
                  <SwitchSlider isOn={isEscortRequired} />
                  <SwitchText isOn={isEscortRequired}>
                    {isEscortRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
              <SwitchRow>
                <SwitchLabel> Additional Notification</SwitchLabel>
                <Switch
                  isOn={isadditionalNotify}
                  onClick={toggleadditionalNotifyRequired}
                >
                  <SwitchSlider isOn={isadditionalNotify} />
                  <SwitchText isOn={isadditionalNotify}>
                    {isadditionalNotify ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
              <SwitchRow>
                <SwitchLabel> On Behalf</SwitchLabel>
                <Switch
                  isOn={isbehalfNotify}
                  onClick={togglebehalfNotifyRequired}
                >
                  <SwitchSlider isOn={isbehalfNotify} />
                  <SwitchText isOn={isbehalfNotify}>
                    {isbehalfNotify ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
            </SwitchContainer>
            <InputFieldContainer>
              <InputLabelN>
                On Behalf Notify to:{isbehalfNotify && <Asterisk> *</Asterisk>}
              </InputLabelN>
              <ChipContainer>
                {onBehalfEmail && (
                  <Chip>
                    {onBehalfEmail}
                    <RemoveChipButton onClick={() => setOnBehalfEmail("")}>
                      &times;
                    </RemoveChipButton>
                  </Chip>
                )}
                {!onBehalfEmail && (
                  <InputField
                    value={inputValueBehalf}
                    onChange={handleBehalfInputChange}
                    placeholder="Enter email ID"
                    disabled={!isbehalfNotify}
                  />
                )}
              </ChipContainer>
              {filteredBehalfSuggestions.length > 0 && (
                <SuggestionBox>
                  {filteredBehalfSuggestions.map((emp) => (
                    <SuggestionItem
                      key={emp.id}
                      onClick={() =>
                        handleBehalfSuggestionClick(emp.employeeMailId)
                      }
                    >
                      {emp.employeeMailId} - {emp.employeeName}
                    </SuggestionItem>
                  ))}
                </SuggestionBox>
              )}
            </InputFieldContainer>
            <InputFieldContainer>
              <InputLabelN>
                Notify to:{isadditionalNotify && <Asterisk> *</Asterisk>}
              </InputLabelN>
              <ChipContainer>
                {selectedEmails.map((email, index) => (
                  <Chip key={index}>
                    {email}
                    <RemoveChipButton onClick={() => handleChipRemove(email)}>
                      &times;
                    </RemoveChipButton>
                  </Chip>
                ))}
                <InputField
                  value={inputValue}
                  onChange={handleInputChangeN}
                  onKeyDown={handleKeyDown}
                  disabled={!isadditionalNotify}
                  placeholder="Enter email ID"
                />
              </ChipContainer>
              {filteredSuggestions.length > 0 && (
                <SuggestionBox>
                  {filteredSuggestions.map((emp) => (
                    <SuggestionItem
                      key={emp.id}
                      onClick={() => handleSuggestionClick(emp.employeeMailId)}
                    >
                      {emp.employeeMailId} - {emp.employeeName}
                    </SuggestionItem>
                  ))}
                </SuggestionBox>
              )}
            </InputFieldContainer>

            {/* Additional Input Fields */}
            <InputFieldContainer>
              <InputLabel>Message to Visitors:</InputLabel>
              <StyledTextArea
                value={additionalMessage}
                onChange={handleAdditionalMessageChange}
                placeholder="Enter message here"
                rows={recurrencePattern === "1" ? 3 : 6} // Adjust as needed for the number of lines shown by default
              />
            </InputFieldContainer>

            <InputFieldContainer>
              <InputLabel>Check-In Instructions:</InputLabel>
              <StyledTextArea
                value={checkInInstructions}
                onChange={handleCheckInInstructionsChange}
                placeholder="Enter instructions here"
                rows={recurrencePattern === "1" ? 3 : 6} // Adjust as needed for the number of lines shown by default
              />
            </InputFieldContainer>
          </Card>
        </CardContainer>
      </TabContent>
      {isPopupVisiblePrivacy && (
        <PopupOverlay>
          <PopupContent>
            <h3>Privacy Policy</h3>
            <p>
              While visiting facilities ("Facilities"), the visitor may have
              access to or receive some information that is secret or
              proprietary to Fidrox (collectively ‘Company’) concerning their
              business or technology. The visitor undertakes to adhere by the
              rules of this Agreement respecting the confidentiality of any
              Confidential Information to which he or she has access or
              receives.
            </p>
            <p>
              “Confidential Information”: for purpose of this Agreement shall
              mean and include, any and all information in written, electronic,
              verbal or other form relating directly or indirectly to the
              present or potential business, operation or financial condition of
              or relating including, but not limited to, information pertaining
              to pricing, marketing plans or strategy, volumes, services
              rendered, customers and suppliers lists, financial or technical or
              service matters or data, trade secrets, designs, programming
              codes, personal or sensitive data of any related parties,
              intellectual property, and any information which might reasonably
              be presumed to be proprietary or confidential in nature and also
              includes all information identified by Company as confidential.
            </p>
            <p>I agree that:</p>
            <ul>
              <li>
                I have access to confidential information, I shall not release,
                publish, or disclose such information to unauthorized personnel.
                I shall protect such information and will employ all reasonable
                efforts to maintain the confidentiality of such information.
              </li>
              <li>
                I shall immediately notify the Company-security personnel of any
                suspected or confirmed unauthorized disclosure and/or misuse of
                confidential information.
              </li>
              <li>
                I shall not make any sound recordings, take any photographs or
                make any movies, copies or reproductive images (in any medium)
                of anything at the facility (ies); Upon Company’s request, I
                shall promptly return all Confidential Information received from
                Company together with all copies, or certify in writing that all
                such Confidential Information and copies thereof have been
                destroyed.
              </li>
              <li>
                While entering Company data center, I consent for my personal
                body and my belongings (baggage, luggage, electronic gadgets,
                etc.) for security frisking purposes.
              </li>
              <li>
                Company may collect certain personal information with relation
                to the purpose of this agreement that is visiting data
                center(s). I acknowledge it in detail at{" "}
                <a
                  href="https://www.fidrox.com/privacy-policy/"
                  target="_blank"
                >
                  https://www.fidrox.com/privacy-policy/
                </a>
                .
              </li>
              <li>
                This Agreement shall remain in effect until such time as all
                Confidential Information of Company disclosed hereunder becomes
                publicly known without my action or inaction.
              </li>
            </ul>
            <ButtonContainer>
              <CloseButton onClick={handleClosePopupPrivacy}>Close</CloseButton>
            </ButtonContainer>
          </PopupContent>
        </PopupOverlay>
      )}
      {isPopupVisibleCovid && (
        <PopupOverlay>
          <PopupContent>
            <h3>Covid Fitness </h3>
            <p>
              The basic preventive measures include simple public health
              measures that are to be followed to reduce the risk of infection
              with COVID-19. These measures need to be observed by all
              (employees and visitors) at all times. These include: Physical
              distancing of at least one meter to be followed at all times. Use
              of face covers/masks to be mandatory. Practice frequent hand
              washing (for at least 40-60 seconds) even when hands are not
              visibly dirty and use of alcohol based hand sanitizers (for at
              least 20 seconds). Respiratory etiquettes to be strictly followed.
              This involves strict practice of covering one’s mouth and nose
              while coughing/sneezing with a tissue/handkerchief/flexed elbow
              and disposing off used tissues properly. Self-monitoring of health
              by all and reporting any illness at the earliest.Place the ill
              person in a room or area where they are isolated from others at
              the workplace. Provide a mask/face cover till such time he/she is
              examined by a doctor. Report to concerned central/state health
              authorities. Helpline 1075 will be immediately informed. A risk
              assessment will be undertaken by the designated public health
              authority (district RRT/treating physician) and accordingly
              further advice shall be made regarding management of case, his/her
              contacts and need for disinfection. The suspect case if reporting
              very mild / mild symptoms on assessment by the health authorities
              would be placed under home isolation, subject to fulfilment of
              criteria laid down in MoHFW guidelines. Suspect case, if assessed
              by health authorities as moderate to severe, he/she will follow
              guidelines as laid down by MoHFW. The rapid response team of the
              concerned district shall be requisitioned and will undertake the
              listing of contacts. The necessary actions for contact tracing and
              disinfection of work place will start once the report of the
              patient is received as positive. The report will be expedited for
              this purpose.
            </p>

            <ButtonContainer>
              <CloseButton onClick={handleClosePopupCovid}>Close</CloseButton>
            </ButtonContainer>
          </PopupContent>
        </PopupOverlay>
      )}
      {isPopupVisible && (
        <Popup>
          <PopupText>
            {existingData.groupLeaderName}- Name is exists for this number.
            Click update to save new name or Click cancel
          </PopupText>
          <ButtonContainer>
            <PopupButton onClick={onConfirm}>Update</PopupButton>
            <PopupButton className="no-button" onClick={onClose}>
              Cancel
            </PopupButton>
          </ButtonContainer>
        </Popup>
      )}

      <ToastContainer />
    </Container>
  );
};

export default AppoinmentFormPage;
